import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/shared/store/store';

export const selectTrialDaysRemaining = (state: RootState): number =>
  state.trial.daysRemaining;

export const selectTrialEnabled = (state: RootState): boolean =>
  state.trial.trialEnabled;

export const selectTrialEndsAt = (state: RootState): string | null =>
  state.trial.trialEndsAt;

export const selectIsInTrial = (state: RootState): boolean =>
  state.trial.isInTrial;

export const selectTrialLoading = (state: RootState): boolean =>
  state.trial.loading;

export const selectTrialError = (state: RootState): string | null =>
  state.trial.error;

// Selector memoizado para evitar re-renders innecesarios
export const selectTrialInfo = createSelector(
  [
    selectTrialDaysRemaining,
    selectTrialEnabled,
    selectTrialEndsAt,
    selectIsInTrial,
    selectTrialLoading,
    selectTrialError,
  ],
  (daysRemaining, trialEnabled, trialEndsAt, isInTrial, loading, error) => ({
    daysRemaining,
    trialEnabled,
    trialEndsAt,
    isInTrial,
    loading,
    error,
  })
);



